<!--
 * @Author: your name
 * @Date: 2019-10-24 09:38:20
 * @LastEditTime: 2020-10-25 22:48:48
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/components/afifx.vue
-->
<template>
  <div>
    <!-- <z-aiffx
      :ossUrl="ossUrl"
      :ossType="ossType"
      :nuxtUrl="nuxtUrl"
      :nextUrl="nextUrl"
      @getOssType="getOssType()"
      @uploadHanlde="uploadHanlde"
    ></z-aiffx> -->
    <common-contact />
    <favorites ref="favorites"></favorites>
  </div>
</template>

<script>
import axios from "axios";
import Favorites from "./favorites.vue";
import CommonContact from "./common/contact";
export default {
  components: { Favorites, CommonContact },
  data() {
    return {
      ossType: {},
      ossUrl: this.ossPrefix,
      nuxtUrl: process.env.VUE_APP_NUXT_BASIC_URL,
      nextUrl: process.env.VUE_APP_NEXT_BASIC_URL,
    };
  },
  methods: {
    getOssType() {
      axios.get(`/designer_api/files/policy?type=3`).then((res) => {
        this.ossType = res;
      });
    },
    /** 上传灵感源&产品 */
    uploadHanlde(data, type) {
      if (type === "uploadInspiration") {
        let params = data.inspiration;
        axios
          .post(`/designer_api/resource_upload/inspiration`, params)
          .then((res) => {
            this.$refs.favorites.open(res.id, "inspiration", {
              imgFile: res.inspirationFile,
              title: res.describe,
            });
          });
      }
      if (type === "uploadProduct") {
        let params = data;
        axios
          .post(`/designer_api/resource_upload/product`, params)
          .then((res) => {
            this.$refs.favorites.open(res.id, "product", {
              imgFile: res.coverFile,
              title: res.name,
            });
          });
      }
    },

    /* 打开 收藏弹框 */
    handleOpenCollect(data, type) {
      this.$refs.favorites.open(-1, type, data);
    },
  },
};
</script>
